// extracted by mini-css-extract-plugin
export default {"helloworld":"Home_helloworld__V38aV","overlay":"Home_overlay__7+whg","popup":"Home_popup__fryCk","topSeparator":"Home_topSeparator__IFW7m","bookNowA":"Home_bookNowA__H8FGP"};